/**
 * SpeedmasterWarranty.Cart.Confirmation.js
 * Keeps the add-to-cart confirmation popup simple — no warranty actions.
 * Warranty opt-in is handled exclusively in the Cart Summary panel.
 *
 * This module is a no-op placeholder. It exists so that Shopping.js
 * can require it without breaking if a future enhancement adds logic.
 */
define('SpeedmasterWarranty.Cart.Confirmation', [], function () {
    'use strict';

    return {
        loadModule: function loadModule() {
            // No-op — warranty is managed only in Cart Summary
        }
    };
});
